"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.canPlayWebm = exports.getAnimationData = void 0;
var JSZip = __importStar(require("jszip"));
var hosted_assets_1 = require("@kaizen/hosted-assets");
/**
 * Fetch and unzip dotlottie files
 * @param path
 */
var getAnimationData = function (path) { return __awaiter(void 0, void 0, void 0, function () {
    var animationData, parsedResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAnimationData((0, hosted_assets_1.assetUrl)(path))];
            case 1:
                animationData = _a.sent();
                return [4 /*yield*/, parseAnimationData(animationData)];
            case 2:
                parsedResponse = _a.sent();
                return [2 /*return*/, parsedResponse];
        }
    });
}); };
exports.getAnimationData = getAnimationData;
var fetchAnimationData = function (path) { return __awaiter(void 0, void 0, void 0, function () {
    var response, blob;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(path)];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                return [2 /*return*/, blob];
            case 3: throw new Error("Lottie asset failed to load ".concat(response.status));
        }
    });
}); };
/**
 * Unzip the dotlottie file to form a format that the lottie-web player understands.
 * Each directory needs to be unzipped separately
 *
 * Dotlottie has the following folder structure when unzipped:
 * ├─ manifest.json
 * ├─ animations
 * │  ├─ animation-1.json
 * │  └─ animation-2.json
 * ├─ images
 * │  ├─ img_1.json
 * │  └─ img_2.json
 * ├─ fonts
 * |- js
 * |- resources
 * └─ previews
 *
 * Reference: {@link https://dotlottie.io/structure/}
 * @param animationData dotlottie file (compressed)
 */
var parseAnimationData = function (animationData) { return __awaiter(void 0, void 0, void 0, function () {
    var deserialize_1, manifestFile, animations, defaultLottie, lottieFile, lottieJson, deserializeImages, err_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 6]);
                return [4 /*yield*/, JSZip.loadAsync(animationData)];
            case 1:
                deserialize_1 = (_c.sent()) || {};
                if (!deserialize_1) {
                    throw new Error("Asset invalid");
                }
                return [4 /*yield*/, ((_a = deserialize_1 === null || deserialize_1 === void 0 ? void 0 : deserialize_1.file("manifest.json")) === null || _a === void 0 ? void 0 : _a.async("string"))];
            case 2:
                manifestFile = _c.sent();
                if (!manifestFile) {
                    throw new Error("Manifest file corrupt");
                }
                animations = JSON.parse(manifestFile).animations;
                if (!animations || animations.length === 0) {
                    throw new Error("No animations listed in the manifest");
                }
                defaultLottie = animations[0];
                return [4 /*yield*/, ((_b = deserialize_1 === null || deserialize_1 === void 0 ? void 0 : deserialize_1.file("animations/".concat(defaultLottie.id, ".json"))) === null || _b === void 0 ? void 0 : _b.async("string"))];
            case 3:
                lottieFile = _c.sent();
                if (!lottieFile) {
                    throw new Error("No animations listed in the manifest");
                }
                lottieJson = JSON.parse(lottieFile);
                deserializeImages = lottieJson.assets.map(function (asset) {
                    if (!asset.p) {
                        return;
                    }
                    return new Promise(function (resolve) {
                        var _a;
                        (_a = deserialize_1 === null || deserialize_1 === void 0 ? void 0 : deserialize_1.file("images/".concat(asset.p))) === null || _a === void 0 ? void 0 : _a.async("base64").then(function (assetB64) {
                            asset.p = "data:;base64," + assetB64;
                            asset.e = 1;
                            resolve();
                        });
                    });
                });
                // deserialize and mutate the lottieJson with the uncompressed data
                return [4 /*yield*/, Promise.all(deserializeImages)];
            case 4:
                // deserialize and mutate the lottieJson with the uncompressed data
                _c.sent();
                return [2 /*return*/, lottieJson];
            case 5:
                err_1 = _c.sent();
                throw new Error("" + err_1);
            case 6: return [2 /*return*/];
        }
    });
}); };
/**
 * Detect whether the current browser can play webm files
 */
var canPlayWebm = function () {
    if (typeof window === "undefined")
        return false;
    // Don't trust Safari's canPlayType implementation, as there is partial support for webm
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
        return false;
    }
    // Attempt webm feature detection
    var video = document.createElement("video");
    if (video.canPlayType("video/webm; codecs=vp9") === "probably") {
        return true;
    }
    return false;
};
exports.canPlayWebm = canPlayWebm;
//# sourceMappingURL=utils.js.map